import React, { Component } from "react";
import PropTypes from "prop-types";

import Modal from "react-modal";

import localize from "lang/localize";

import "./DeleteCompletionDialog.css";

const propTypes = {
  showModal: PropTypes.bool.isRequired,
  claimId: PropTypes.number.isRequired,
  handleCloseDeleteCompletionDialog: PropTypes.func.isRequired,
  handleClickDelete: PropTypes.func.isRequired,
  language: PropTypes.string
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== "test") {
  Modal.setAppElement("#root");
}

class DeleteCompletionDialog extends Component {
  render() {
    return (
      <Modal
        isOpen={this.props.showModal}
        contentLabel={localize("delete_submission", this.props.language) + "?"}
        onRequestClose={this.props.handleCloseDeleteCompletionDialog}
        shouldCloseOnOverlayClick={false}
        className="dialog delete-completion-dialog"
        overlayClassName="dialog-overlay"
      >
        <div className="dialog-content">
          <div className="dialog-header">
            <h5 className="dialog-title">
              {localize("delete_submission", this.props.language) + "?"}
            </h5>
          </div>
          <div className="dialog-body">
            {localize("delete_claim_text", this.props.language)}
          </div>
          <div className="dialog-footer">
            <div className="textright">
              <button
                className="button inline"
                onClick={this.props.handleCloseDeleteCompletionDialog}
                id="cancelButton"
              >
                {localize("web_confirm_cancel_text", this.props.language)}
              </button>
              <button
                className="button inline danger"
                onClick={this.props.handleClickDelete}
                id="deleteCompletionButton"
              >
                {localize("web_confirm_yes_text", this.props.language)}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

DeleteCompletionDialog.propTypes = propTypes;

export default DeleteCompletionDialog;
